<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-form @submit.stop.prevent="onSubmit">
        <v-text-field
          class="mr-6"
          v-model="filters.keyword"
          :label="filterLabel"
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
          @click:clear="onClear"
          @input="debouncedSearch"
        />
      </v-form>
      <FilterTable
        :filter-label="filterLabel"
        filter-key="isActive"
        select-label="Status"
        @filter-change="handleFilterChange"
        :selected-filter="true"
      />

      <v-btn
        fab
        small
        :to="{
          name: 'content',
          params: { id: 0 }
        }"
        v-if="$privilege.hasPrivilege('CONTENT_CREATE')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :server-items-length="total"
        :options.sync="options"
        :loading="isLoading"
      >
        <template v-slot:item.contentKey="{ item }"
          ><router-link :to="{ name: 'content', params: { id: item.id } }">{{ item.contentKey }}</router-link></template
        >
        <template v-slot:item.participantTypes="{ item }">
          <v-chip color="warning" v-if="item.participantTypes && item.participantTypes.length == 0">No one</v-chip>
          <div v-else v-html="renderSortedParticipantTypes(item.participantTypes)"></div>
        </template>
        <template v-slot:item.effective="{ item }">
          <v-chip color="primary" v-if="item.effective">{{ $i18n.translate("Active") }}</v-chip>
          <v-chip color="danger" v-else>{{ $i18n.translate("Inactive") }}</v-chip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import FilterTable from "@/gapp-components/components/tables/FilterTable.vue";

export default {
  components: {
    FilterTable
  },
  name: "Contents",
  props: {
    pageTitleKey: {
      type: String,
      default: "Contents"
    }
  },
  metaInfo() {
    return {
      title: this.pageTitleKey
    };
  },
  data() {
    return {
      items: [],
      filterByEffective: "Active",
      filters: { keyword: null, isActive: true, participantType: null },
      isLoading: false,
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["updatedDate"],
        sortDesc: [true]
      },
      effectiveItems: [
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" },
        { text: "All", value: "All" }
      ],
      headers: [
        {
          value: "contentKey",
          text: "Content Key",
          sortable: true
        },
        {
          value: "description",
          text: "Description",
          sortable: true
        },
        {
          value: "participantTypes",
          text: "Visibility"
        },
        {
          value: "effective",
          text: "Status",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  methods: {
    onSubmit() {
      if (this.options.page !== 1) {
        this.options.page = 1;
      } else {
        this.fetchData();
      }
    },
    async fetchData() {
      this.isLoading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const sortQuery = sortBy.length > 0 ? `&sort=${sortBy[0]},${sortDesc[0] ? "DESC" : "ASC"}` : "";

      if (!this.isGappInternalUser) {
        this.filters.participantType = { id: this.selectedParticipant?.participantType?.id };
      }

      try {
        let { data } = await this.$api.post(
          `/api/contents/search?size=${itemsPerPage}&page=${page - 1}${sortQuery}&expand=participantTypes`,
          this.filters
        );
        this.items = data.content;
        this.total = data.totalElements;

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    handleFilterChange(filter) {
      this.filters[filter.key] = filter.value;
      this.onSubmit();
    },
    onClear() {
      this.filters.keyword = "";
      this.onSubmit();
    },
    renderSortedParticipantTypes(participantTypes) {
      let returnValue = "";

      let copiedParticipantTypes = Object.assign([], participantTypes);

      copiedParticipantTypes.sort((a, b) => {
        return a.participantTypeKey.localeCompare(b.participantTypeKey);
      });
      for (let i in copiedParticipantTypes) {
        returnValue +=
          "<div style='white-space: nowrap'>" +
          copiedParticipantTypes[i].participantTypeKey +
          " - " +
          copiedParticipantTypes[i].name +
          "</div>";
      }
      return returnValue;
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["selectedParticipant"]),
    isGappInternalUser() {
      return this.$privilege.isGappInternalUser();
    },
    pageTitle() {
      return this.$i18n.translate(this.pageTitleKey);
    },
    filterLabel() {
      return this.$i18n.translate("Filter") + " " + this.pageTitle;
    }
  }
};
</script>
